import { render, staticRenderFns } from "./works-list.vue?vue&type=template&id=13fe2eaf&scoped=true"
import script from "./works-list.vue?vue&type=script&lang=js"
export * from "./works-list.vue?vue&type=script&lang=js"
import style0 from "./works-list.vue?vue&type=style&index=0&id=13fe2eaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fe2eaf",
  null
  
)

export default component.exports